import {JSON_MIME_TYPE} from '../../utils/extensions';
import {IStationApi} from '../../api/station-api.service';
import {ISnowData, ISnowDataRow, ISnowDataResponse, IStation} from '../../api/api.types';
import {IImomoErrorService} from '../../error/error.service';
import IUploadService = angular.angularFileUpload.IUploadService;
import {IStationDetailsStateParams} from '../details/details.controller';
import {StateService} from 'angular-ui-router';
import * as moment from 'moment';
import StationMapService from '../station-map.service';
import {IStationMap} from '../station-map.service';
import {IHydrodataDatum, IHydrodataTimeseries} from '../../hydromet/timeseries/timeseries.controller';
import ITimeseriesService from '../timeseries/timeseries.service';
import IOrganizationApi from '../../api/organization-api.service';

enum IDataFileState {
  Unselected, Selected, Validating, Invalid, Valid
}

interface IDataFileIcon {
  name:string,
  cssClass:string
}

export default class SnowDataController {
  static $inject = ['$state', 'organizationApi', '$stateParams', 'stationApi', 'imomoErrorService', 'Upload', '$rootScope',
    'stationMapService', 'uiGmapGoogleMapApi', 'timeseriesService', '$translate', '$mdDialog', '$window'];
  private static readonly YEAR_RANGE_SIZE = 100;
  private static readonly JOURNAL_YEARS: number[] = _.range(
      moment().year() - SnowDataController.YEAR_RANGE_SIZE,
      moment().year() + 1);

  dataFile:File;
  dataFileState:IDataFileState;
  stationId: number;
  station: IStation;
  loadingInProgress: boolean;
  snowDataLoadingInProgress: boolean;
  isLoadingGeotiff: boolean;
  snowDataPromise: ng.IPromise<ISnowData>;
  snowDataRows: IHydrodataDatum[] = [];
  snowDataSeries: IHydrodataTimeseries[];
  isSnowDataFileDownloadEnabled: boolean;
  snowDataFileDownloadLink: string;
  map: IStationMap;
  geojson: any;
  isCatchmentMissing: boolean = false;
  geoTiffDate: moment.Moment;
  yearType: string;
  heatmapValues: any = {
"0": "rgb(255, 0, 0)",
"1": "rgb(249, 6, 0)",
"2": "rgb(244, 11, 0)",
"3": "rgb(239, 16, 0)",
"4": "rgb(234, 21, 0)",
"5": "rgb(229, 26, 0)",
"6": "rgb(224, 31, 0)",
"7": "rgb(219, 36, 0)",
"8": "rgb(214, 41, 0)",
"9": "rgb(209, 46, 0)",
"10": "rgb(204, 51, 0)",
"11": "rgb(198, 57, 0)",
"12": "rgb(193, 62, 0)",
"13": "rgb(188, 67, 0)",
"14": "rgb(183, 72, 0)",
"15": "rgb(178, 77, 0)",
"16": "rgb(173, 82, 0)",
"17": "rgb(168, 87, 0)",
"18": "rgb(163, 92, 0)",
"19": "rgb(158, 97, 0)",
"20": "rgb(153, 102, 0)",
"21": "rgb(147, 108, 0)",
"22": "rgb(142, 113, 0)",
"23": "rgb(137, 118, 0)",
"24": "rgb(132, 123, 0)",
"25": "rgb(127, 128, 0)",
"26": "rgb(122, 133, 0)",
"27": "rgb(117, 138, 0)",
"28": "rgb(112, 143, 0)",
"29": "rgb(107, 148, 0)",
"30": "rgb(102, 153, 0)",
"31": "rgb(96, 159, 0)",
"32": "rgb(91, 164, 0)",
"33": "rgb(86, 169, 0)",
"34": "rgb(81, 174, 0)",
"35": "rgb(76, 179, 0)",
"36": "rgb(71, 184, 0)",
"37": "rgb(66, 189, 0)",
"38": "rgb(61, 194, 0)",
"39": "rgb(56, 199, 0)",
"40": "rgb(50, 205, 0)",
"41": "rgb(45, 210, 0)",
"42": "rgb(40, 215, 0)",
"43": "rgb(35, 220, 0)",
"44": "rgb(30, 225, 0)",
"45": "rgb(25, 230, 0)",
"46": "rgb(20, 235, 0)",
"47": "rgb(15, 240, 0)",
"48": "rgb(10, 245, 0)",
"49": "rgb(5, 250, 0)",
"50": "rgb(0, 255, 0)",
"51": "rgb(0, 250, 5)",
"52": "rgb(0, 245, 10)",
"53": "rgb(0, 240, 15)",
"54": "rgb(0, 235, 20)",
"55": "rgb(0, 230, 25)",
"56": "rgb(0, 225, 30)",
"57": "rgb(0, 220, 35)",
"58": "rgb(0, 215, 40)",
"59": "rgb(0, 210, 45)",
"60": "rgb(0, 205, 50)",
"61": "rgb(0, 199, 56)",
"62": "rgb(0, 194, 61)",
"63": "rgb(0, 189, 66)",
"64": "rgb(0, 184, 71)",
"65": "rgb(0, 179, 76)",
"66": "rgb(0, 174, 81)",
"67": "rgb(0, 169, 86)",
"68": "rgb(0, 164, 91)",
"69": "rgb(0, 159, 96)",
"70": "rgb(0, 154, 101)",
"71": "rgb(0, 148, 107)",
"72": "rgb(0, 143, 112)",
"73": "rgb(0, 138, 117)",
"74": "rgb(0, 133, 122)",
"75": "rgb(0, 128, 127)",
"76": "rgb(0, 123, 132)",
"77": "rgb(0, 118, 137)",
"78": "rgb(0, 113, 142)",
"79": "rgb(0, 108, 147)",
"80": "rgb(0, 102, 153)",
"81": "rgb(0, 97, 158)",
"82": "rgb(0, 92, 163)",
"83": "rgb(0, 87, 168)",
"84": "rgb(0, 82, 173)",
"85": "rgb(0, 77, 178)",
"86": "rgb(0, 72, 183)",
"87": "rgb(0, 67, 188)",
"88": "rgb(0, 62, 193)",
"89": "rgb(0, 57, 198)",
"90": "rgb(0, 51, 204)",
"91": "rgb(0, 46, 209)",
"92": "rgb(0, 41, 214)",
"93": "rgb(0, 36, 219)",
"94": "rgb(0, 31, 224)",
"95": "rgb(0, 26, 229)",
"96": "rgb(0, 21, 234)",
"97": "rgb(0, 16, 239)",
"98": "rgb(0, 11, 244)",
"99": "rgb(0, 6, 249)",
"100": "rgb(0, 0, 255)"
};
  /**
   * Selected year model.
   */
  selectedYear: number;
  /**
   * Hard-coded years available for selection.
   */
  readonly years: number[];

  constructor(private $state:StateService,
              private organizationApi: IOrganizationApi,
              private $stateParams: IStationDetailsStateParams,
              private stationApi:IStationApi,
              private imomoErrorService: IImomoErrorService,
              private Upload: IUploadService,
              private $rootScope: ng.IRootScopeService,
              private stationMapService: StationMapService,
              private uiGmapGoogleMapApi: any,
              private timeseriesService: ITimeseriesService,
              private $translate:ng.translate.ITranslateService,
              private $mdDialog: ng.material.IDialogService,
              private $window: ng.IWindowService) {
    this.heatmapValues = Object.keys(this.heatmapValues).map(key => this.heatmapValues[key]).reverse()
    this.dataFileState = IDataFileState.Unselected;
    this.stationId = Number.parseInt(this.$stateParams.stationId);
    this.years = SnowDataController.JOURNAL_YEARS;
    this.selectedYear = moment().year();
    this.map = this.stationMapService.getMapOptions();
    this.loadingInProgress = true;
    this.organizationApi
      .getOrganization(Number.parseInt(this.$window.localStorage.getItem('currentOrgId')))
      .then((org) => {
        this.yearType = org.yearType;
      });
    this.stationApi.getDischargeStation({stationId: this.stationId})
      .then((station) => {
        this.station = station;
        this.$rootScope.$broadcast('STATION_LOADED', station);
        this.onLoadSnowData();
        if (this.station) {
          this.stationApi.getCatchmentAreaGeojson(this.station.id, false)
            .then((geojson) => {
              this.isLoadingGeotiff = true;
              this.geojson = geojson;

              uiGmapGoogleMapApi.then((maps: any) => {
                this.map.options.mapTypeId = maps.MapTypeId.TERRAIN;

                let catchmentBounds = this.stationMapService.loadGeoJson(geojson.url, this.map, maps, 0).getCatchmentBounds();

                this.stationApi.getSnowCoverGeotiff(this.station.id)
                  .then((data) => {
                    if (data) {
                      this.geoTiffDate = moment(data.date);
                      this.stationMapService.setOverlay(catchmentBounds, data.url, this.map)
                    }
                  })
                  .catch((error) => {
                    this.imomoErrorService.showErrorDetailsDialog(error.data.details);
                  })
                  .finally(() => {
                    this.isLoadingGeotiff = false;
                  })
              });
              
              
            }, () => {
              this.isCatchmentMissing = true;
              this.loadingInProgress = false;
              //this.map.center = this.marker.coords;
            });
        }
      }).finally(() => {
        this.loadingInProgress = false;
      });
  }

  get isUnselected() {
    return this.dataFileState == IDataFileState.Unselected;
  }

  get isValidating() {
    return this.dataFileState == IDataFileState.Validating;
  }

  get isInvalid() {
    return this.dataFileState == IDataFileState.Invalid;
  }

  get isValidated() {
    return this.dataFileState == IDataFileState.Valid;
  }

  get jsonMimeTypes() {
    return JSON_MIME_TYPE;
  }

  get dataFileStateIcon():IDataFileIcon {
    switch (this.dataFileState) {
      case IDataFileState.Selected:
        return {
          name: 'indeterminate_check_box',
          cssClass: ''
        };
      case IDataFileState.Validating:
        return {
          name: 'cached',
          cssClass: ''
        };
      case IDataFileState.Valid:
        return {
          name: 'check_circle',
          cssClass: 'md-accent'
        };
      case IDataFileState.Invalid:
        return {
          name: 'error_outline',
          cssClass: 'md-warn'
        };
      default:
        return {
          name: '',
          cssClass: ''
        };
    }
  }

  onDataFileChange = (files:Array<File>) => {
    if (files && files[0]) {
      this.dataFile = files[0];
      this.dataFileState = IDataFileState.Selected;
    } else {
      this.dataFileState = IDataFileState.Unselected;
      this.dataFile = null;
    }

  };

  onDataUpload() {

    this.Upload.base64DataUrl(this.dataFile)
      .then((jsonstring) => {
        this.stationApi.uploadSnowData(this.stationId, jsonstring)
          .then(() => {
            this.$state.go(this.$state.current, {}, {reload: true});
          })
          .catch((error: any) => {
            this.imomoErrorService.showErrorDetailsDialog(error.data.details)
          })
          .finally(() => {
            this.loadingInProgress = false;
          });
      });
  }

  getSnowDataGroupedByYear(snowData: ISnowDataRow[]) {
    let snowDataSeriesDataList:IHydrodataTimeseries[] = [];
    let snowDataSeriesTemplate:any =  {
      label: null,
      data: []
    };
    let year = 0;
    snowData.forEach((snowDataRow, index) => {
      if (index === 0) {
        year = moment(snowDataRow.date).year();
        snowDataSeriesTemplate.label = this.yearType === "hydro_year" ? year + 1 : year;
      } else if (
        index === (snowData.length - 1) || 
        (
          this.yearType === "hydro_year" && (
            moment(snowDataRow.date).month() === 8 && moment(snowDataRow.date).date() === 30 ||
            (
              (moment(snowDataRow.date).month() !== 11 && moment(snowDataRow.date).date() !== 31) &&
              moment(snowDataRow.date).year() !== moment(snowData[index + 1].date).year()
            )
          )
        ) ||
        (
          this.yearType === "calendar_year" && (
            moment(snowDataRow.date).month() === 0 && moment(snowDataRow.date).date() === 1 ||
            (
              (moment(snowDataRow.date).month() !== 11 && moment(snowDataRow.date).date() !== 31) &&
              moment(snowDataRow.date).year() !== moment(snowData[index + 1].date).year()
            )
          )
        )
      ) {
        snowDataSeriesTemplate.data.push({
          date: moment(snowDataRow.date),
          hydrodata: snowDataRow.value
        });
        snowDataSeriesDataList.push(angular.copy(snowDataSeriesTemplate));
        year = ++year;
        snowDataSeriesTemplate.label = this.yearType === "hydro_year" ? year + 1 : year;
        snowDataSeriesTemplate.data = [];
      } else {
        snowDataSeriesTemplate.data.push({
          date: moment(snowDataRow.date),
          hydrodata: snowDataRow.value
        });
      }
    })
    snowDataSeriesDataList[snowDataSeriesDataList.length -1].current = true;
    snowDataSeriesDataList[snowDataSeriesDataList.length -1].highlighted = true;

    return snowDataSeriesDataList;
  }

  onLoadSnowData() {
    this.snowDataLoadingInProgress = true;
    this.snowDataPromise = this.stationApi.getSnowData(this.stationId);
    this.snowDataPromise
       .then((snowData) => {
           let snowDataSeries: IHydrodataTimeseries[] = []
           let snowDataNormSeries: IHydrodataTimeseries;
           let snowDataNormRangeSeries: any;
          if (snowData && snowData.snowData ) {

            this.stationApi.getSnowDataNorm(this.stationId)
              .then(snowDataNorm => {
                snowDataNormSeries = {
                  label: this.$translate.instant('NDSI_NORM'),
                  data: _.sortBy(snowDataNorm.snowDataNorm.map((snowDataRow) => {
                    return {
                      date: moment().month(snowDataRow.month - 1).date(snowDataRow.day),
                      hydrodata: snowDataRow.value
                    }
                  }), 'date'),
                  highlighted: true
                };

                snowDataNormRangeSeries = {
                  id: "SD",
                  label: this.$translate.instant('NDSI_NORM') + " +-1SD",
                  data: _.sortBy(snowDataNorm.snowDataNorm.map((snowDataRow) => {
                    return {
                      date: moment().month(snowDataRow.month - 1).date(snowDataRow.day),
                      hydrodata: [(snowDataRow.value + snowDataRow.std), (snowDataRow.value - snowDataRow.std)]
                    }
                  }), 'date'),
                };
                
              })
              .finally(() => { 
                 this.getSnowDataGroupedByYear(snowData.snowData).forEach((list) => {
                   snowDataSeries.push(list);
                 })

                snowDataSeries.push(snowDataNormSeries);
                snowDataSeries.push(snowDataNormRangeSeries)

                this.snowDataSeries = snowDataSeries;
                this.snowDataLoadingInProgress = false;
              });
          } else {
            this.snowDataLoadingInProgress = false;
          }

         this.stationApi.getSnowDataFile(this.stationId, this.selectedYear)
           .then((s3url) => {
             this.isSnowDataFileDownloadEnabled = true;
             this.snowDataFileDownloadLink = s3url.url;
           })
           .catch((error: any) => {
             this.imomoErrorService.showErrorDetailsDialog(error.data.details)
           })
       })
       .catch((error: any) => {
         this.imomoErrorService.showErrorDetailsDialog(error.data.details)
         this.snowDataLoadingInProgress = false;
       })

  }

  onDeleteCatchmentArea() {
    let confirm = this.$mdDialog.confirm()
        .title('')
        .textContent(this.$translate.instant('DELETE_CATCHMENT_CONFIRM'))
        .ok(this.$translate.instant('DELETE'))
        .cancel(this.$translate.instant('CANCEL'));

    this.$mdDialog.show(confirm).then(() => {
      this.stationApi.deleteCatchmentArea(this.stationId)
        .then(() => {
          this.isCatchmentMissing = true;
          this.snowDataFileDownloadLink = null;
        });
    });
  }

}



/** WEBPACK FOOTER **
 ** ./app/station/snow-data/snow-data.controller.ts
 **/